import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const WishlistContext = createContext(null);
const KEY = "yoyo_wishlist";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = useCallback((id) => items.some((p) => p.id === id), [items]);
  const toggle = useCallback((product) => {
    setItems((prev) => prev.some((p) => p.id === product.id)
      ? prev.filter((p) => p.id !== product.id)
      : [...prev, { id: product.id, nom: product.nom, prix: product.prix, images: (product.images || []).slice(0, 1), taille: product.taille, etat_client: product.etat_client, type: product.type, disponibilite: product.disponibilite, tags: product.tags || [] }]);
  }, []);

  const value = useMemo(() => ({ items, has, toggle, count: items.length }), [items, has, toggle]);
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export const useWishlist = () => useContext(WishlistContext);
